import { useEffect, useState } from "react";
import { FileCheck, User, Car, Scale, Loader2 } from "lucide-react";
import api from "@/lib/api";

export const LegalChecklistPais = ({ pais, compact = false }) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    api.get(`/api/paises/${pais}`)
      .then(({ data }) => { if (alive) setConfig(data); })
      .catch(() => { if (alive) setConfig(null); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [pais]);

  if (loading) {
    return (
      <div className="flex items-center gap-2 text-xs text-slate-400 py-3" data-testid="legal-checklist-loading">
        <Loader2 size={13} className="animate-spin" /> Cargando requisitos legales…
      </div>
    );
  }
  if (!config) return null;

  return (
    <div data-testid={`legal-checklist-${pais}`} className="space-y-4">
      <div className="rounded-lg bg-[#13315C] text-white px-4 py-3">
        <p className="text-[10px] uppercase tracking-widest font-bold text-[#F5B301]">Marco legal · {config.nombre}</p>
        <p className="text-sm font-semibold mt-0.5">{config.via_legal}</p>
        <p className="text-[11px] text-white/70 mt-1">{config.registro} · {config.tiempo_estimado}</p>
      </div>

      <div>
        <p className="text-xs font-bold text-[#13315C] mb-2 flex items-center gap-1.5"><Scale size={13} /> Pasos del proceso</p>
        <ol className="space-y-1.5">
          {config.flujo.map((f) => (
            <li key={f.paso} className="flex gap-2.5 text-xs">
              <span className="shrink-0 w-5 h-5 rounded-full bg-[#F5B301]/15 text-[#13315C] font-bold text-[10px] flex items-center justify-center">{f.paso}</span>
              <span>
                <span className="font-semibold text-[#13315C]">{f.titulo}.</span>{" "}
                <span className="text-slate-500">{f.desc}</span>
              </span>
            </li>
          ))}
        </ol>
      </div>

      {!compact && (
        <div className="grid sm:grid-cols-3 gap-3" data-testid="legal-docs-grid">
          <DocList icon={User} title="Comprador" items={config.documentos.comprador} />
          <DocList icon={User} title="Vendedor" items={config.documentos.vendedor} />
          <DocList icon={Car} title="Vehículo" items={config.documentos.vehiculo} />
        </div>
      )}

      <div className="rounded-lg bg-amber-50 border border-amber-200 px-3 py-2.5">
        {config.notas_legales.map((n, i) => (
          <p key={i} className="text-[10.5px] text-amber-800 leading-snug">⚠️ {n}</p>
        ))}
        <p className="text-[10px] text-amber-700/70 mt-1.5">{config.ley_proteccion_datos} · {config.ley_firma}</p>
      </div>
    </div>
  );
};

const DocList = ({ icon: Icon, title, items }) => (
  <div className="rounded-lg border border-slate-200 bg-white p-3">
    <p className="text-[11px] font-bold text-[#13315C] mb-1.5 flex items-center gap-1"><Icon size={12} /> {title}</p>
    <ul className="space-y-1">
      {items.map((d, i) => (
        <li key={i} className="flex gap-1.5 text-[10.5px] text-slate-600 leading-snug">
          <FileCheck size={11} className="text-[#10B981] shrink-0 mt-0.5" /> {d}
        </li>
      ))}
    </ul>
  </div>
);
